import { BrandIdCategoryId } from './brand-id-category-id.model';

export class UpdatePhotographer {
  public PhotographerId: number;
  public StatusId: number;
  public ShotCost: number;
  public MaxItems: number;
  public DiscountThreshold: number;
  public DiscountPercentage: number;
  public StartDate: string;
  public EndDate: string;
  public AutomaticRenewal?: boolean;
  public BrandIdCategoryId: BrandIdCategoryId[];

  constructor(init?: Partial<UpdatePhotographer>) {
    Object.assign(this, init);
  }
}
